import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { campaignsApi, staticAdv } from '@/api/index';
import type { CampaignRequestFilters } from '@/api/routes/campaigns/types';

export const fetchCampaignsFilters = createAsyncThunk(
  'campaignFilters',
  async (params: CampaignRequestFilters, thunkAPI) => {
    try {
      const response = await campaignsApi.getFilters(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticCampaignsFilters = createAsyncThunk(
  'campaignFilters',
  async (params, thunkAPI) => {
    try {
      const response = await staticAdv.getFilters();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
